var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOndas = function SvgOndas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B985C",
    fillRule: "evenodd",
    d: "M6 0v14h-.857V0H6zm6.857 1.944v10.112H12V1.944h.857zm-8.571.39v9.333h-.857V2.333h.857zm3.428.777V10.5h-.857V3.111h.857zm3.429.778v6.222h-.857V3.89h.857zm3.428.389v5.444h-.857V4.278h.857zm-12 .389v4.277h-.857V4.667h.857zm6.858.389v3.5H8.57v-3.5h.858zm6.857.777v2.334h-.857V5.833h.857zm1.714.39v1.555h-.857V6.222H18zm-17.143 0v1.555H0V6.222h.857z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOndas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ondas.5bfd7475.svg";
export { ForwardRef as ReactComponent };